export default (state = [], action) => {
  switch (action.type){
    case 'CREATE_ORDER':
        return [...state, Object.assign({}, action.order)];

    case 'GET_ORDERS':
    	return action.orders;
	
	 case 'UPDATE_ORDER':
		var newState=[];
		for(let i=0; i<state.length; i++){
			//console.log('UPDATE_ORDER ['+i+'] amb id '+state[i].id)
			if(state[i].id!==action.order.id){
				newState.push(state[i]);
			}else{
				newState.push(action.order);
			}
		}
		return newState;
		
	case 'GET_TMX_MATCH':
//		console.log('GET_TMX_MATCH reducer STATE:');
		var temp = state;
		temp[action.id_order].tmx_match=action.tmx_match;
		return(temp);
    default:
          return state;
  }
};